import { createFileRoute, redirect } from "@tanstack/react-router";
import { allPages } from "@/lib/all-pages";

/**
 * Legacy WordPress state archives (/location-type/illinois/) map to the
 * current state hub pages (/locations/illinois).
 */
export const Route = createFileRoute("/location-type/$slug")({
  beforeLoad: ({ params }) => {
    const slug = params.slug.toLowerCase().replace(/^\/+|\/+$/g, "");
    const target = `https://restorehair.com/locations/${slug}`;
    const known = allPages.some((p) => p.replace(/\/+$/, "") === target);
    throw redirect({
      href: known ? `/locations/${slug}/` : "/locations/",
      statusCode: 301,
    });

  },
});
